import { render } from "./CreateProductPage.vue?vue&type=template&id=0c5a915f&scoped=true&ts=true"
import script from "./CreateProductPage.vue?vue&type=script&lang=ts"
export * from "./CreateProductPage.vue?vue&type=script&lang=ts"

import "./CreateProductPage.vue?vue&type=style&index=0&id=0c5a915f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c5a915f"]])

export default __exports__